<template>
  <div>
    <h5 class="d-flex justify-content-center">{{ title }}</h5>
    <canvas :id="idCanva" class="w-100 my-auto"></canvas>
    <LoadingCover v-show="loading" />
  </div>
</template>
<script>
  import { ref } from "vue";
  import { uuid } from "vue-uuid";
  import { Chart, LinearScale, CategoryScale } from "chart.js";
  import ChartDataLabels from "chartjs-plugin-datalabels";
  import { FunnelController, TrapezoidElement } from "chartjs-chart-funnel";

  import { formatter } from "@/general";
  import {
    dataKPIDirectoryQuatity,
  } from "@/apiData";

  import LoadingCover from "@/components/containers/LoadingCover.vue";

  Chart.register(FunnelController, TrapezoidElement, LinearScale, CategoryScale, ChartDataLabels);

  export default {
    name: "CustomerPenetrationChart",
    data() {
      return {
        uuid,
        formatter,
        loading: false,
        dataValues: []
      }
    },
    props: {
      title: String,
      initialDate: String,
      finalDate: String,
      idStaffGroup: String,
      idEmployee: String
    },
    components: {
      LoadingCover
    },
    methods: {
      async getDataCustomerPenetration(typeIndicator) {
        let parameters = {
          "Tipo_Consulta": typeIndicator,
          "Fecha_Inicial": this.initialDate,
          "Fecha_Final": this.finalDate,
          "Id_GrupoEmpleado": this.idStaffGroup,
          "Id_Vendedor": this.idEmployee,
          "Cantidad_Ventas": 2
        }

        try {
          const { response } = await dataKPIDirectoryQuatity(this, parameters);
          // const loadValues = {
          //   "AC": () => this.dataValues.push(response.Cantidad),
          //   "CC": () => this.dataValues.push(response.Cantidad),
          //   "CA": () => this.dataValues.push(response.Cantidad),
          //   "default": () => this.dataValues.push(0)
          // }
          
          // loadValues[typeIndicator]();

          return response.Cantidad;
        } catch (error) {
          console.log(error);
        }
      },
      setupChart(totalClientes) {
        const ctx = document.getElementById(this.idCanva).getContext("2d");

        // // Now you can use 'ctx' to draw on the canvas
        // // For example, drawing a rectangle:
        // ctx.beginPath();
        // ctx.rect(50, 50, 100, 75);
        // ctx.fillStyle = 'blue';
        // ctx.fill();
        // ctx.lineWidth = 2;
        // ctx.strokeStyle = 'black';
        // ctx.stroke();

        const options = {
          responsive: true,
          indexAxis: "y",
          plugins: {
            datalabels: {
              // backgroundColor: "#abc123",
              // display: (ctx) => {
              //   return ctx.dataset.data[ctx.dataIndex] > 25;
              // },
              font: {
                size: 14
              },
              formatter: (value, ctx) => {
                const name =  ctx.chart.data.labels[ctx.dataIndex];
                let label = value;

                if (name !== "Activos") {
                  const participacion = ((value / totalClientes) * 100);
                  label = `${value}\n${participacion.toFixed(2)}%`;
                }

                // if (value > 25) {
                //   label = `${value}`;
                // } else {
                //   label = value;
                // }
                
                return label;
              }
            }
          }
        }

        const chart = new Chart(ctx, {
          type: "funnel",
          data: {
            labels: ["Activos", "Atendidos", "Cotizados", "Ventas", "Fidelizados"],
            datasets: [
              {
                data: this.dataValues,
                backgroundColor: ["#FF6384", "#36A2EB", "#FFCE56", "#bed868", "#edfea7"],
                shrinkAnchor: "top",
              },
            ],
          },
          options: options
        });

        chart.update();
      }
    },
    computed: {

    },
    setup() {
      const idCanva = ref("");
      idCanva.value = uuid.v1();

      return {
        idCanva
      }
    },
    async mounted() {
      this.loading = true;

      const clientesActivos = await this.getDataCustomerPenetration("CR");
      const clientesCotizados = await this.getDataCustomerPenetration("CC");
      const clientesVentas = await this.getDataCustomerPenetration("CA");
      const clientesAtendidos = (clientesCotizados + clientesVentas);
      const clientesCantidadVentas = await this.getDataCustomerPenetration("VC");
      
      this.dataValues.push(clientesActivos);
      this.dataValues.push(clientesAtendidos);
      this.dataValues.push(clientesCotizados);
      this.dataValues.push(clientesVentas);
      this.dataValues.push(clientesCantidadVentas);

      this.setupChart(clientesActivos);

      this.loading = false;
    },
    beforeDestroy() {

    }
  }
</script>
